import { render, staticRenderFns } from "./HAOPView.vue?vue&type=template&id=8bbca8b2&scoped=true&"
import script from "./HAOPView.vue?vue&type=script&lang=ts&"
export * from "./HAOPView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bbca8b2",
  null
  
)

export default component.exports